// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-cell_default__1vasa","fill":"idt-cell_fill__tgq13","fit":"idt-cell_fit__1txpk"};